/// <amd-module name="Artifacts/Npm/NpmConstants" />

export class NpmCiConstants {
  public static BugEmailLinkClicked = "NpmBugEmailLinkClicked";
  public static BugUrlLinkClicked = "NpmBugUrlLinkClicked";
  public static HomepageLinkClicked = "NpmHomepageLinkClicked";
}
